import * as Yup from 'yup';

export const formValidationSchema = Yup.object().shape({
  tgl_penerimaan_aset: Yup.string().required('Masukan tanggal'),
  no_surat_jalan_vendor: Yup.string().required('Masukan no surat jalan vendor'),
  id_petugas_penerimaan: Yup.string().required('Pilih petugas penerimaan'),
  bukti_penerimaan: Yup.string().required('Masukan bukti penerimaan'),
});
